import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Product, Table } from 'services/action';

const ProductStatus = ({ data }) => {
  const Dispatch = useDispatch();
  const StateTable = useSelector((state) => state?.Table?.data['product']);

  const $handleToogle = async (data) => {
    if (data?.is_active) {
      await Dispatch(Product.$deactivated(data?.id));
      Dispatch(Table.$reload('product', StateTable));
    } else {
      await Dispatch(Product.$activated(data?.id));
      Dispatch(Table.$reload('product', StateTable));
    }
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <label className="mb-1 form-switch text-center">
        <input
          defaultChecked={data?.is_active}
          className="form-check-input"
          type="checkbox"
          onChange={() => $handleToogle(data)}
        />
      </label>
      <div className="text-center page-pretitle">
        {data?.is_active === true ? 'Aktif' : 'Tidak Aktif'}
      </div>
    </div>
  );
};

export default ProductStatus;
